import React from "react";
import { Create, SimpleForm, TextInput, SelectInput, required, useRedirect, useNotify, usePermissions } from "react-admin";

const UserCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const {permissions} = usePermissions();
  if(permissions < 1){
    return;
  }
  return (
    <Create mutationMode="pessimistic"        
      mutationOptions={{ 
        onSuccess: () => {
          notify('作成が完了しました', { type: 'success' }); 
          // redirect('list', 'users');
          window.location.reload();
        }
      }}
    >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
        <TextInput source="userName" label="ユーザー名" validate={required()} />
        <TextInput source="name" label="名前" validate={required()}/>
        <TextInput source="password" label="パスワード" type="password" validate={required()} />
        <TextInput source="mail" label="メール" type="email" />
        <SelectInput
          source="userType"
          label="ユーザー種別"
          choices={[
            { id: 0, name: "一般スタッフ" },
            { id: 1, name: "管理スタッフ" },
            // { id: 2, name: "マスター" },
          ]}
          validate={required()}
        />
      </SimpleForm>
    </Create>
  );

};

export default UserCreate;
